import { Grid, Card, CardContent, Stack, Typography } from '@mui/material';

import OrderSummary from '../../../models/order/orderSummary.model';
import formatNumberToCurrency from '../../../util/formaters/formatNumberToCurrency';

interface Props {
  orders: OrderSummary[];
  totalizador?: number;
}

const OrdersQueryResultsTotalizersCard = (props: Props) => {
  const { orders, totalizador } = props;
  const ordersTotal =
    totalizador ??
    orders.reduce((total, order) => total + order.totalPedido, 0);

  return (
    <Grid item xs={12} md={12}>
      <Card sx={{ width: '100%', boxShadow: 2 }}>
        <CardContent
          sx={{
            mt: -0.5,
            padding: 0.5,
            '&:last-child': {
              paddingBottom: 0.25,
            },
          }}
        >
          <Stack
            direction={'row'}
            width={'100%'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Typography variant='body2' fontWeight={'Bold'} mt={1}>
              Total de pedidos : {orders.length}
            </Typography>
            <Typography variant='body2' fontWeight={'Bold'} mt={1}>
              Valor total dos pedidos : {formatNumberToCurrency(ordersTotal)}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default OrdersQueryResultsTotalizersCard;
